export enum Platforms {
	MOBILE = 'mobile',
	PANEL = 'panel',
	COMPONENT = 'component',
	VIDEO = 'video',
	WEB = 'web',
}

export enum HomeTabs {
	COMMANDS = 'commands',
	HFX = 'hfx',
	LEADERBOARD = 'leaderboard',
}

export const HomeTabNames = {
	[HomeTabs.COMMANDS]: 'Commands',
	[HomeTabs.HFX]: 'HFX',
	[HomeTabs.LEADERBOARD]: 'Leader Board',
};
